import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CategoryCard from "../categoryCard/CategoryCard";
import ProductList from "../productList/ProductList";
import NotFoundProduct from "../notFoundProduct/NotFoundProduct";

const Search = () => {
  const { product, value } = useSelector((state) => state.search);  // grab `value` from Redux state
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
        <div className="flex pt-10 lg:py-12">
          <div className="flex w-full">
            <div className="w-full">
              <CategoryCard />
              {product && product.length >= 1 ? (
                <ProductList 
                  key={value || "default-key"}  
                  data={product} 
                />
              ) : (
                <NotFoundProduct />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;